import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios, doRequestAxiosAll } from 'srcReact/helpers/apiHelper'

export const myHomeService = {
  getMyHomeAll,
  getMixrList,
  getGroupList,
  getAllInvitations,
  getMyHomeSuggestedMixrs,
  getMyHomeSuggestedGroups
}

function getMyHomeAll(
  id_workplace,
  latitude,
  longitude,
  future_mixr_list_offset,
  future_mixr_list_quantity,
  past_mixr_list_offset,
  past_mixr_list_quantity,
  group_list_offset,
  group_list_quantity
) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      id_workplace,
      latitude,
      longitude,
      future_mixr_list_offset,
      future_mixr_list_quantity,
      past_mixr_list_offset,
      past_mixr_list_quantity,
      group_list_offset,
      group_list_quantity
    }
  }
  return doRequestAxios(`/v2/myhome/all`, requestOptions)
}

function getMyHomeSuggestedMixrs(
  id_workplace,
  latitude,
  longitude,
  suggested_mixr_list_offset,
  suggested_mixr_list_quantity
) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      id_workplace,
      latitude,
      longitude,
      suggested_mixr_list_offset,
      suggested_mixr_list_quantity
    }
  }
  return doRequestAxios(`/v2/myhome/all`, requestOptions)
}

function getMyHomeSuggestedGroups(
  id_workplace,
  latitude,
  longitude,
  suggested_group_list_offset,
  suggested_group_list_quantity
) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      id_workplace,
      latitude,
      longitude,
      suggested_group_list_offset,
      suggested_group_list_quantity
    }
  }
  return doRequestAxios(`/v2/myhome/all`, requestOptions)
}

function getMixrList(id_workplace, latitude, longitude, is_mixr_over, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { id_workplace, latitude, longitude, is_mixr_over, offset, quantity }
  }

  return doRequestAxios(`/v2/myhome/mixr-list`, requestOptions)
}

function getGroupList(id_workplace, latitude, longitude, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { id_workplace, latitude, longitude, offset, quantity }
  }
  return doRequestAxios(`/v2/myhome/group-list`, requestOptions)
}

function getAllInvitations(id_workplace) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  const mixrInvitesRequest = `/v2/myhome/mixr-invitations?id_workplace=${id_workplace}`
  const groupInvitesRequest = `/v2/myhome/group-invitations?id_workplace=${id_workplace}`
  return doRequestAxiosAll([mixrInvitesRequest, groupInvitesRequest], requestOptions)
}
